var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKupt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 64,
    viewBox: "0 0 56 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.0033 23H12.9967L28 31.0793L43.0033 23ZM56 21.02V13H7.8119e-07V21.0208V23V47.977C-2.60339e-07 47.9785 -2.60454e-07 47.9799 7.8119e-07 47.9814V51H2.97318C2.97542 51 2.97765 51 2.97989 51H53.0201H53.0268H56V47.9815V47.9769V23V21.0216C56 21.0211 56 21.0205 56 21.02ZM50.0481 26.0477L34.3522 34.5L50.0481 42.9523V26.0477ZM21.6478 34.5L5.95192 26.0477V42.9523L21.6478 34.5ZM14.7183 45.0729L28 37.9207L41.2817 45.0729H14.7183Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKupt);
export default __webpack_public_path__ + "static/media/kupt.5eb577a92a785623fc24e28d27c5e965.svg";
export { ForwardRef as ReactComponent };